import { cn } from "@/common/helpers/utils";
import { CopyableValue, CopyableValueIconPosition } from "@/components/copyable-value/copyable-value";
import { EmptyValue } from "@/components/ui/empty-value";

export const SystemIdRow = ({
  label,
  value,
  mono = false,
  copyable = false,
}: {
  label: string;
  value?: string;
  mono?: boolean;
  copyable?: boolean;
}) => {
  return (
    <div className="flex items-center justify-between gap-4 py-1">
      <span className="text-muted-foreground text-sm">{label}</span>
      {value ? (
        <span className={cn("text-sm", mono && "font-mono")}>
          {copyable ? <CopyableValue value={value} iconPosition={CopyableValueIconPosition.Left} /> : value}
        </span>
      ) : (
        <EmptyValue />
      )}
    </div>
  );
};
